import React from 'react';
import Track from '../index';
import './style.scss';

const useMobile = (LowerComponent) => {
    return class extends React.Component {
        render() {
            return (
                <LowerComponent {...this.props} />
            )
        }
    }
}

const TrackMobile = useMobile(Track);

export default TrackMobile;